import { Link } from "react-router-dom";

const Logo = ({ size = "md" }) => {
  const heights = { sm: "h-9", md: "h-12 sm:h-14", lg: "h-20" };
  const h = heights[size] || heights.md;

  return (
    <Link to="/" data-testid="logo-home-link" className="flex items-center" aria-label="Produlimp BV — Limpieza & Bazar">
      <img src="/logo.png?v=5" alt="Produlimp BV — Limpieza & Bazar" className={`${h} w-auto object-contain`} />
    </Link>
  );
};

export default Logo;
